import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '@/lib/api';

const SalonProfileContext = createContext(null);

export function SalonProfileProvider({ children }) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProfile = useCallback(async () => {
    if (!localStorage.getItem('salon_token')) {
      setLoading(false);
      return null;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await api.get('/salon-profile');
      const p = res.data;
      setProfile({
        ...p,
        salonName: p.salon_name ?? p.salonName ?? '',
      });
      return p;
    } catch (err) {
      setError(err);
      setProfile(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  const value = {
    profile,
    loading,
    error,
    refreshProfile: fetchProfile,
    salonName: profile?.salon_name ?? profile?.salonName ?? '',
  };

  return (
    <SalonProfileContext.Provider value={value}>
      {children}
    </SalonProfileContext.Provider>
  );
}

export function useSalonProfile() {
  const ctx = useContext(SalonProfileContext);
  if (!ctx) throw new Error('useSalonProfile must be used within SalonProfileProvider');
  return ctx;
}
